define('shared/remote/queryproxy/validate',['$', 'Promise'], function ($, Promise) {
    return function(accessToken) {
        return new Promise(function(rs){
            return $.ajax({
                url: '/1/api/school-proxy/v1/troop?' + 
                    ['q', 'efid!current'].join('='),
                type: 'GET',
                dataType: 'json',
                headers: {
                    Authorization: 'Bearer ' + accessToken
                }
            })
            .promise()
            .then(function(){
                rs(true);
            }, function(){
                rs(false);
            });
        });
    };
});
